module.exports = __webpack_public_path__ + "assets/img/mutton_chop_active.afdfb94d.png";